/**
 * TaskPortalDashboardService
 * Service for task dashboard portal operations.
 * Provides dashboard stats, unseen tasks, and in-progress tasks.
 * Route: api/task-portal/dashboard
 */
import { TaskPortalBaseService } from './TaskPortalBaseService';
export class TaskPortalDashboardService extends TaskPortalBaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? TaskPortalDashboardService.DEFAULT_SERVICE_PATH,
            basePath: config?.basePath ?? 'api/task-portal/dashboard',
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get dashboard statistics for the current user.
     */
    async getStats() {
        const response = await this.get('stats');
        return response.data;
    }
    /**
     * Get dashboard statistics (raw response).
     */
    async getStatsRaw() {
        return this.get('stats');
    }
    /**
     * Get unseen tasks (statusID = 0) for the current user.
     */
    async getUnseenTasks() {
        const response = await this.get('unseen');
        return response.data ?? [];
    }
    /**
     * Get unseen tasks (raw response).
     */
    async getUnseenTasksRaw() {
        return this.get('unseen');
    }
    /**
     * Get in-progress tasks (status not in [0, 3, 4]) for the current user.
     */
    async getInProgressTasks() {
        const response = await this.get('in-progress');
        return response.data ?? [];
    }
    /**
     * Get in-progress tasks (raw response).
     */
    async getInProgressTasksRaw() {
        return this.get('in-progress');
    }
    /**
     * The current user's Upcoming surface: scheduled tasks they are assigned to
     * or created, plus previews of the next occurrence of each active recurring
     * series (those rows do not exist yet — occurrences materialise at start).
     * GET /api/task-portal/dashboard/upcoming
     */
    async getUpcoming() {
        const response = await this.getUpcomingRaw();
        return response.data ?? { scheduledTasks: [], nextOccurrences: [] };
    }
    getUpcomingRaw() {
        return this.get('upcoming');
    }
}
TaskPortalDashboardService.DEFAULT_SERVICE_PATH = 'tasks';
//# sourceMappingURL=TaskPortalDashboardService.js.map